<template>
  <v-btn>
    <v-icon>mdi-arrow-left</v-icon>
    <span>Tilbage</span>
  </v-btn>
</template>